export const focusedBorder = 'rounded-[20px] outline-disable outline-primary-12';
export const yellowFocusedBorder = 'rounded-[20px] outline-disable outline-secondary-8';
export const focusedBannerBorder = 'focus:border-white focus:border-2 hover:border-white hover:border-2';

export const menuButton = `focus:bg-menu-focused focus:outline-disable hover:bg-menu-focused hover:outline-disable`;
export const selectedMenuIcon = 'focus:outline-disable focus:bg-[#F8F3D4] hover:outline-disable hover:bg-[#F8F3D4]';
